document.addEventListener("DOMContentLoaded", function () {
  const removeTrustpilot = () => {
    const tp = document.getElementById("trustpilot-widget-trustbox-0-wrapper");
    if (tp) {
      tp.remove();
      observer.disconnect();
    }
  };
  removeTrustpilot();
  const observer = new MutationObserver(removeTrustpilot);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
